import {
    normalizeMeasureAttributes,
    typeAttributeKeys,
    extractibleAttributeKeys,
} from "@treegram/viewer-core";

class MeasureType {
    measureTypeId: string;

    measureRepresentationId: string;

    measureShapeId: string;

    name: string;

    dataInformations: Record<string, unknown> | undefined = undefined;

    dataFormatType: Record<string, unknown> | undefined = undefined;

    dataFormatInstance: Record<string, unknown> | undefined = undefined;

    constructor(
        measureTypeId: string,
        measureRepresentationId: string,
        measureShapeId: string,
        name: string,
        dataInformations?: Record<string, unknown>,
    ) {
        this.measureTypeId = measureTypeId;
        this.measureRepresentationId = measureRepresentationId;
        this.measureShapeId = measureShapeId;
        this.name = name;
        this.dataInformations = normalizeMeasureAttributes(measureRepresentationId, dataInformations);
        this.dataFormatType = Object.fromEntries(
            typeAttributeKeys(measureRepresentationId, this.dataInformations).map((key) => [
                key,
                ({ color: "hex", symbol: "text" } as Record<string, string>)[key] ?? "number",
            ]),
        );
        this.dataFormatInstance = Object.fromEntries(
            extractibleAttributeKeys(measureRepresentationId, this.dataInformations)
                .filter((key) => key !== "number" && !Object.hasOwn(this.dataFormatType!, key))
                .map((key) => [key, "number"]),
        );
    }
}

export default MeasureType;
